import { scheduleAccess, titleOf as scheduleTitleOf } from '../schedule/scheduleModel';

// Operative programmes (Firestore collection "files"): see schedule/scheduleModel.js for the
// period, unit and documents; a programme also has a type (commentType / comment).
export { dayOf, documentsOf, legacyLinks, periodLabel, periodOf, toKey, todayKey } from '../schedule/scheduleModel';

export const TYPES = ['Normal', 'Mission Canadienne', 'Mission Suisse'];
export const TYPE_OPTIONS = [...TYPES.map((type) => ({ value: type, label: type })), { value: 'Autres', label: 'Autre' }];

export const typeOf = (item) => {
  if (TYPES.includes(item.commentType) || item.commentType === 'Autres') return item.commentType;
  const comment = String(item.comment || '').trim();
  if (!comment) return 'Normal';
  return TYPES.includes(comment) ? comment : 'Autres';
};
export const typeLabel = (item) => (typeOf(item) === 'Autres' ? String(item.comment || '').trim() || 'Autre' : typeOf(item));

export const titleOf = (item) => scheduleTitleOf(item, 'Programme opératoire');

// Prepared by the secretaries (rights grid: the other roles only consult).
export const programmeAccess = (user) => scheduleAccess(user, 'programme');
